<template>
  <tickets-header-list>
    <template v-slot:create>
      <div @click="openItemModal(null)" class="btn btn-sm btn-success ms-auto">Создать абонемент</div>
    </template>
  </tickets-header-list>
  <div v-if="!loaded" class="card card-body p-0 border-top border-top-1 border-gray-200">
    <div class="table-responsive custom-table">
      <table class="table table-hover table-rounded table-striped table-row-dashed fs-7 table-row-gray-300 gy-5 custom-table align-middle mb-0">
        <thead>
        <tr class="fw-bold fs-8 text-gray-400">
          <th>Код</th>
          <th>Название</th>
          <th>Номинал</th>
          <th>Ед. изм.</th>
          <th>Срок действия</th>
          <th class="text-end">Действие</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, key) in specs" :key="key">
          <td>{{ item.code }}</td>
          <td>{{ item?.label?.value }}</td>
          <td>{{ item?.nominal?.value }}</td>
          <td>{{ item?.nominal?.currency?.label }}</td>
          <td>{{ item.validityPeriod }} {{ item.validityPeriodUnit }}</td>
          <td class="text-end">
            <div class="d-flex justify-content-end">
              <span @click="openItemModal(item.id)" class="ps-2 ms-1 py-1 cursor-pointer text-hover-primary"><i class="ki-outline ki-pencil fs-5"></i></span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center border-top py-3">
      <div class="btn-group">
        <button class="btn btn-sm btn-light" :disabled="page === 0" @click="goToPage(page - 1)">
          <i class="ki-outline ki-arrow-left"></i>
        </button>
        <button
            v-for="(p, i) in visiblePages"
            :key="i"
            class="btn btn-sm btn-light"
            :class="{
              'text-gray-600': p !== '...' && page !== p,
              'text-success fw-bold': p !== '...' && page === p,
              'btn-disabled text-muted': p === '...'
            }"
            :disabled="p === '...'"
            @click="p !== '...' && goToPage(p)"
        >
          {{ p === '...' ? '...' : p + 1 }}
        </button>
        <button class="btn btn-sm btn-light" :disabled="page === totalPages - 1 || totalPages === 0" @click="goToPage(page + 1)">
          <i class="ki-outline ki-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
  <div v-else class="card rounded">
    <loader />
  </div>
  <ticket-modal v-if="showModal" :ticket-id="changeId" :d-currency="dCurrency" @closeModal="closeModal"/>
</template>

<script>
import TicketsHeaderList  from '@/views/EnergoGoClub/Tickets/TicketsHeaderList'
import TicketModal from '@/views/EnergoGoClub/Tickets/TicketList/TicketModal'
import Loader from "@/components/Loader.vue";
import {notify} from '@kyvg/vue3-notification'
import axios from 'axios'

export default {
  name: 'TicketList',
  components: {Loader, TicketModal, TicketsHeaderList},
  data() {
    return {
      loaded: false,
      specs: null,
      page: 0,
      size: 20,
      totalPages: 0,
      changeId: null,
      showModal: false,
      dCurrency: null,
    }
  },
  computed: {
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.page;
      if (total <= 7) {
        for (let i = 0; i < total; i++) pages.push(i);
      } else {
        pages.push(0);
        if (current > 3) pages.push('...');
        const start = Math.max(1, current - 1);
        const end = Math.min(total - 2, current + 1);
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
        if (current < total - 4) pages.push('...');
        pages.push(total - 1);
      }
      return pages;
    }
  },
  mounted() {
    this.getSpecs()
    this.getDicCurrency()
  },
  methods: {
    getSpecs() {
      this.loaded = true
      axios.get('/api/v1/billing/issuer/tickets/specs', {params: {page: this.page, size: this.size}})
          .then(res => {
            if (res.data && res.data.content) {
              this.specs = res.data.content
              this.page = res.data.pageable?.pageNumber || 0
              const totalElements = res.data.pageable?.totalElements || 0
              this.totalPages = Math.ceil(totalElements / this.size) || 1
            } else {
              this.specs = []
              this.totalPages = 1
            }
          })
          .catch(err => {
            notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message,});
            this.specs = []
            this.totalPages = 1
          })
          .finally(() => this.loaded = false)
    },
    getDicCurrency() {
      this.loaded = true
      axios.get('/api/v1/resources/book/items', {params: {catalog: 'currency'}})
          .then(res => {
            this.dCurrency = res.data.content
          })
          .catch(err => {
            notify({duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: err?.response?.data?.errorDescription ?? err.message,});
          })
          .finally(() => this.loaded = false)
    },
    openItemModal(id) {
      this.showModal = true;
      this.changeId = id;
      setTimeout(() => {
        const modalEl = document.getElementById('ticketModal');
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }, 10);
    },
    closeModal(isUpdate) {
      this.showModal = false;
      if (isUpdate) this.getSpecs();
    },
    goToPage(newPage) {
      if (newPage >= 0 && newPage < this.totalPages) {
        this.page = newPage;
        this.getSpecs();
      }
    },
  }
}
</script>

<style scoped>

</style>